import { render, staticRenderFns } from "./ScreenMechanism.vue?vue&type=template&id=e6b1b566&scoped=true"
import script from "./ScreenMechanism.vue?vue&type=script&lang=js"
export * from "./ScreenMechanism.vue?vue&type=script&lang=js"
import style0 from "./ScreenMechanism.vue?vue&type=style&index=0&id=e6b1b566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b1b566",
  null
  
)

export default component.exports